/** Inline field validation for contact forms — returns an error string or null when valid. */

/** Pragmatic email shape check (not RFC-exhaustive): something@something.tld. */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/** Empty is allowed (a contact needs only a name); a filled value must look like an email. */
export function validateEmail(value: string): string | null {
  const v = value.trim()
  if (!v) return null
  return EMAIL_RE.test(v) ? null : 'Enter a valid email address.'
}

/**
 * Phone: allow digits, spaces and + - ( ) (not strict E.164), but require a
 * reasonable minimum of digits so obvious typos are caught.
 */
export function validatePhone(value: string): string | null {
  const v = value.trim()
  if (!v) return null
  if (!/^[\d\s+()-]+$/.test(v)) return 'Use digits, spaces and + - ( ) only.'
  const digits = v.replace(/\D/g, '')
  return digits.length >= 6 ? null : 'Enter at least 6 digits.'
}
